


export const ChartBars = () => (
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M3 20C3 19.4477 3.44772 19 4 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20Z" />
		<path fillRule="evenodd" clipRule="evenodd" d="M6 3C6.55228 3 7 3.44772 7 4V16C7 16.5523 6.55228 17 6 17C5.44772 17 5 16.5523 5 16V4C5 3.44772 5.44772 3 6 3ZM14 5C14.5523 5 15 5.44772 15 6V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V6C13 5.44772 13.4477 5 14 5ZM18 11C18.5523 11 19 11.4477 19 12V16C19 16.5523 18.5523 17 18 17C17.4477 17 17 16.5523 17 16V12C17 11.4477 17.4477 11 18 11ZM11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V8Z" />
	</svg>
);
